import { PaymentProviderType } from "@/types/graphql/partner.generated";
import { useInstanceQuery } from "./useInstanceQuery";

/**
 * Набор до фазы платёжных провайдеров инстанса: карточки всех трёх
 * провайдеров показывались на любой платформе. Он же фолбэк, если запрос
 * возможностей инстанса не ответил: отказ вспомогательного запроса не
 * должен отнимать у партнёра настройки оплаты.
 */
const ALL_PAYMENT_PROVIDERS: PaymentProviderType[] = [
  PaymentProviderType.StripeType,
  PaymentProviderType.PaynetType,
  PaymentProviderType.CcbillType,
];

/**
 * Платёжные провайдеры развёртывания (`instance.paymentProviders`): на
 * ottkit.io это Stripe и Paynet, на adult-инстансе только CCBill.
 * Настройки платформы показывают карточку подключения ровно тех
 * провайдеров, что попали в этот список, а бэкенд отклоняет подключение
 * остальных (PaymentSettingsService.assertProviderAvailable).
 *
 * `null` означает «ответ ещё не пришёл»: карточку в этот момент не
 * рисуем, иначе на ottkit.io мелькнёт CCBill, а на adult-инстансе Stripe.
 */
export function useInstancePaymentProviders(): PaymentProviderType[] | null {
  const { data, loading } = useInstanceQuery();

  if (data?.instance) return data.instance.paymentProviders;

  return loading ? null : ALL_PAYMENT_PROVIDERS;
}
